import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-16-spinner.tsx
/**
* icon.16.spinner
*
* Keywords: refresh, reload, clockwise, rotation, circular, update, sync, cycle
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTAuNzc4IDMuODQyYTUgNSAwIDAgMC0yLjI3OS0uODE3QS41NC41NCAwIDAgMSA4IDIuNWEuNDcuNDcgMCAwIDEgLjUtLjQ4QTYgNiAwIDEgMSAyLjAyIDguNS40Ny40NyAwIDAgMSAyLjUgOGMuMjc2IDAgLjQ5Ny4yMjQuNTI1LjQ5OWE1IDUgMCAxIDAgNy43NTMtNC42NTciIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-13167
*/
const Icon16Spinner = memo(function Icon16Spinner(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "16",
		height: "16",
		fill: "none",
		viewBox: "0 0 16 16",
		...props,
		"data-fpl-icon-size": "16",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			fillRule: "evenodd",
			d: "M10.778 3.842a5 5 0 0 0-2.279-.817A.54.54 0 0 1 8 2.5a.47.47 0 0 1 .5-.48A6 6 0 1 1 2.02 8.5.47.47 0 0 1 2.5 8c.276 0 .497.224.525.499a5 5 0 1 0 7.753-4.657",
			clipRule: "evenodd"
		})
	});
});
//#endregion
export { Icon16Spinner };

//# sourceMappingURL=icon-16-spinner.js.map